import {
  Button,
  Dialog,
  Box,

} from "@material-ui/core"
import React, { useState } from "react"
import CloseIcon from "@material-ui/icons/Close"
import WhatsappIcon from "../WhatsappIcon"
import { makeStyles } from "@material-ui/core/styles"
import SendWhatsApp from "../Whatsapp/Whatsapp"

const useStyles = makeStyles(theme => ({
  dialogButton: {
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,
    marginRight: theme.spacing(1),
  },
  closeButton: {
    display: "flex",
    justifyContent: "flex-end",
  },
}))



interface SendWappDialogParams {
  open: boolean
  list: string[]
  handleClose: () => void
}

function SendWhatsappDialog (
  { open, list, handleClose }: SendWappDialogParams,
) {
  const classes = useStyles()
  return (
    <Dialog
      fullScreen
      open={open}
    >
      <Box className={classes.closeButton}>
        <Button
          size='large'
          color='inherit'
          variant='text'
          endIcon={<CloseIcon />}
          onClick={() => handleClose()}
        >Close
        </Button>
      </Box>
      <Box m={4}>
        {/* @ts-expect-error */}
        <SendWhatsApp list={list} />
      </Box>
    </Dialog>
  )
}


interface SendBulkWappParams {
  selectedIds: string[]
  [key: string]: any
}

export default function SendBulkWhatsapp (
  { selectedIds, ...props }: SendBulkWappParams,
) {
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  return (
    <>
      <SendWhatsappDialog
        open={open}
        list={selectedIds}
        handleClose={() => setOpen(false)}
      />
      <Button
        startIcon={<WhatsappIcon />}
        variant='outlined'
        onClick={() => setOpen(true)} className={classes.dialogButton}
      >
        Send WhatsApp
      </Button>
    </>
  )
}
